/* Victorieboontje redesign — mobiel menu (native dialog) en aantal in winkelmand-icoon. */
(function () {
  if (window.__vbChrome) return; window.__vbChrome = true;

  function initMenu() {
    var dialog = document.querySelector('[data-vb-menu]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var opener = document.querySelector('[data-vb-menu-open]');
    function close() { dialog.close(); }
    if (opener) opener.addEventListener('click', function () {
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
    });
    dialog.addEventListener('close', function () { if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); } });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.closest('[data-vb-menu-close]')) close(); });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) { if (e.matches && dialog.open) close(); });
  }

  function setCount(n) {
    document.querySelectorAll('[data-vb-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
    document.querySelectorAll('[data-vb-cart-label]').forEach(function (el) {
      el.setAttribute('aria-label', n > 0 ? 'Winkelmand, ' + n + ' artikelen' : 'Winkelmand');
    });
  }

  function initCart() {
    // Whisk zet na toevoegen de oude icoon-opmaak in #cart-icon-bubble (bij ons een inerte <template>); lees daar het aantal uit.
    var source = document.querySelector('[data-vb-cart-source]');
    if (source && source.content) {
      new MutationObserver(function () {
        var el = source.content.querySelector('.site-header__cart-count [aria-hidden]');
        setCount(el ? parseInt(el.textContent, 10) || 0 : 0);
      }).observe(source.content, { childList: true, subtree: true, characterData: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.cartData && typeof e.cartData.item_count === 'number') setCount(e.cartData.item_count); });
    }
  }

  // Melding "nog € X tot gratis verzending" bovenin het Whisk-winkelmanddrawer (Figma 38:323).
  function fmt(c, f) {
    var p = (c / 100).toFixed(2).split('.'), t = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (f || '€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/, t + ',' + p[1]);
  }
  function initShipping() {
    var h = document.querySelector('[data-vb-header]'), drawer = document.getElementById('cart-drawer');
    var limit = h ? parseInt(h.dataset.freeShip, 10) : 0;
    if (!drawer || !limit) return;
    var box = document.createElement('p'); box.className = 'vb-cart-ship'; box.setAttribute('aria-live', 'polite');
    var head = drawer.querySelector('.drawer__header'); if (head) head.insertAdjacentElement('afterend', box);
    function show(total) {
      var rest = limit - total;
      box.hidden = total === 0;
      box.textContent = rest > 0 ? 'Nog ' + fmt(rest, h.dataset.money) + ' tot gratis verzending (vanaf ' + fmt(limit, h.dataset.money).replace(',00', '') + ')' : 'Je bestelling wordt gratis verzonden';
    }
    show(parseInt(h.dataset.cartTotal, 10) || 0);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        if (e && e.cartData && typeof e.cartData.total_price === 'number') show(e.cartData.total_price);
        else fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { show(c.total_price); });
      });
    }
  }

  // Desktop-uitklapmenu: open bij aanwijzen (met korte vertraging) of via het pijltje; Esc, klik buiten of focus weg sluit.
  function initMega() {
    var items = [].slice.call(document.querySelectorAll('[data-vb-mega-item]'));
    if (!items.length) return;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    function set(item, open) {
      var btn = item.querySelector('[data-vb-mega-toggle]'), panel = item.querySelector('[data-vb-mega]');
      if (!btn || !panel) return;
      panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) { items.forEach(function (i) { if (i !== except) set(i, false); }); }
    items.forEach(function (item) {
      var t;
      item.addEventListener('mouseenter', function () { if (!fine.matches) return; clearTimeout(t); t = setTimeout(function () { closeAll(item); set(item, true); }, 90); });
      item.addEventListener('mouseleave', function () { if (!fine.matches) return; clearTimeout(t); t = setTimeout(function () { set(item, false); }, 220); });
      item.querySelector('[data-vb-mega-toggle]').addEventListener('click', function () {
        var open = this.getAttribute('aria-expanded') !== 'true'; closeAll(item); set(item, open);
        if (open) { var first = item.querySelector('[data-vb-mega] a'); if (first) first.focus(); }
      });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(item, false); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { set(item, false); item.querySelector('[data-vb-mega-toggle]').focus(); }
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-vb-mega-item]')) closeAll(); });
  }

  // Menukliks meten (GA4 via GTM): event vb_nav_click met plek en label.
  function initNavTracking() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-vb-nav]'); if (!a) return;
      var p = a.getAttribute('data-vb-nav').split(':');
      (window.dataLayer = window.dataLayer || []).push({ event: 'vb_nav_click', nav_area: p[0], nav_group: p.length > 2 ? p[1] : '', nav_label: p[p.length - 1] });
    });
  }

  function init() { initMenu(); initCart(); initShipping(); initMega(); initNavTracking(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
